import { createSelector } from '../selectorWrapper'
import { pageSelectors } from '../basicState'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'

export const blockedPageSelector = createSelector(
  [pageSelectors.restriction],
  (restrictionsFragment?: WpsRuntime.atv.wps.RestrictionFragmentModelProps) => {

    return restrictionsFragment && restrictionsFragment.blockedPageModel &&
      { model: restrictionsFragment && restrictionsFragment.blockedPageModel } || undefined
  }
)
